module.exports = "pegasus_template/assets/graycircle-twitter-old.png";